interface IOptions {
  messageOverride?: Record<string, string> // Allows for overriding an error's message based on its code
}

export const getMessageFromError = (
  error: unknown,
  { messageOverride }: IOptions = {}
): string | undefined => {
  if (!error || typeof error !== 'object') return undefined

  // If we're given a messageOverride object, we need to try to use it to get the desired error message for the error code.
  if (messageOverride && 'code' in error) {
    const errorCode = String(error.code)
    if (messageOverride[errorCode]) {
      return messageOverride[errorCode]
    }
  }

  // For all other cases, attempt to use the message from the error as the assumption is that it will be the most descriptive.
  // If the error does not have a message, we will return the custom default message or, worst case, a very generic one.
  const errorMessage = 'message' in error ? String(error.message) : null

  return errorMessage || undefined
}
